export default __webpack_public_path__ + "static/image12-19225eaf92c2950463ef84c98bc65c46.gif";